import { zodResolver } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import {
  type CheckQSetDuplicationRateFormValues,
  CheckQSetDuplicationRateFormSchema,
} from '../../types';
import { CheckQSetDuplicationRateFormModal } from '../check-qset-duplication-rate-form-modal';

interface QSetSimilarityCheckModalProps {
  open: boolean;
  onClose: () => void;
  onFormSubmit: (formData: CheckQSetDuplicationRateFormValues) => Promise<void>;
}

export default function QSetSimilarityCheckModal(props: Readonly<QSetSimilarityCheckModalProps>) {
  const { open: isOpen, onClose, onFormSubmit } = props;

  const formContext = useForm<CheckQSetDuplicationRateFormValues>({
    resolver: zodResolver(CheckQSetDuplicationRateFormSchema),
  });

  return (
    <FormProvider {...formContext}>
      <CheckQSetDuplicationRateFormModal
        open={isOpen}
        onClose={onClose}
        onFormSubmit={onFormSubmit}
      />
    </FormProvider>
  );
}
